/**
 * Creates default display text for a given data type.
 * @param dataType {string} The data type of the column.
 * @returns {string} Default display text based on the data type.
 *
 * This function provides a way to generate default display text for various data types.
 *
 * For numeric and text custom columns we want to return an empty string. Ticket Ref: PEPPERMINT-1664
 */
export const createDefaultDisplayTextForDataType = (dataType: string) => {
  switch (dataType) {
    default:
      return ''; // Default display text
  }
};
